import React, { useEffect, useState } from 'react';
import { Card} from '@americanexpress/dls-react';
import { useParams } from 'react-router-dom';
import { Banner} from '../../components';
import Login from './Login';
import Expiration from './Expiration';

function SaveAndRetrieve() {
    const [data, setFormData] = useState(null);
    const [prospData, setProspData] = useState(null);
    let { id } = useParams();
    useEffect(() => {
        const fetchProspDetail = async () => {
            const result = await fetch(`/api/Prospect/LeadEligibility/${id}`)
                .then(response => response.json())
                .then(json => json)
                .catch(err => { });
            setProspData(result);
            fetchData(result.selectedProduct);
        }

        fetchProspDetail();       
    }, [id]);

    const fetchData = async (selectedProduct) => {
        const result = await fetch(`/api/Content/Journey/TwoStageForm/${selectedProduct}`)
            .then(response => response.json())
            .then(json => json)
            .catch(err => {

            });

        setFormData(result);
    };

    const selectPage = (data,prospData) => {
        if (prospData?.linkActiveIndicator === true) {
            return <Login cardDisplayName={data.journeyContent.productName} id={id} productName = { prospData.selectedProduct }/>
        }      
        else if (prospData?.linkActiveIndicator === false) {
            return <Expiration />
        }
    }

    return (        
        <div className="dls-gray-01-bg">
            <div>
                <div className="row">
                    <div className="col-md-offset-1 col-md-10">
                        <div className="row margin-1-tb">

                            <Card className="col-md-3">
                                {data && (
                                    <>
                                        <Banner cardImage={data.journeyContent.cardArt} bannerTitle={data.journeyContent.bannerTitle}
                                            bannerUrl={data.journeyContent.bannerImageSrc} cardDisplayName={data.journeyContent.cardDisplayName}
                                            eligibilityCriteria={data.journeyContent.eligibilityCriteria} displayCityNames={data.displayCityNames}
                                        />
                                    </>
                                )}
                            </Card>
                            <Card className="col-md-9">
                                <div className="stack body">
                                    <div className="pad-responsive">
                                        {data && prospData && (selectPage(data,prospData))}                                        
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default SaveAndRetrieve;